import React from 'react';
import { motion } from 'framer-motion';
import {
  Wrapper,
  Header,
  ContentWrapper,
  Content,
  HeaderWrapper,
  HamburgerBar,
  CircleBtn,
} from './AccordionCard.styles';
import CloseIcon from '../../icons/CloseIcon';

const AccordionCard = ({ title, text, isActive, onChange, index }) => {
  return (
    <Wrapper key={index} onClick={() => onChange(index)}>
      <HeaderWrapper>
        <Header>{title}</Header>
        {isActive ? (
          <CircleBtn>
            <HamburgerBar />
          </CircleBtn>
        ) : (
          <CircleBtn>
            <CloseIcon />
          </CircleBtn>
        )}
      </HeaderWrapper>
      <motion.div
        style={{ overflow: 'hidden' }}
        initial="collapsed"
        animate={isActive ? 'open' : 'collapsed'}
        exit="collapsed"
        variants={{
          open: { opacity: 1, height: 'auto', margin: '0 0 1.5rem 0' },
          collapsed: { opacity: 0, height: 0 },
        }}
        transition={{ duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98] }}
      >
        <Content dangerouslySetInnerHTML={{ __html: text }} />
      </motion.div>
    </Wrapper>
  );
};

export default AccordionCard;
